import styled from "styled-components";

// Cabecera negra y filas comparten rejilla para que las columnas queden
// alineadas: contenido | imagen | precio | cantidad | total.
const gridTemplate = `
  display: grid;
  grid-template-columns: 1fr 110px 80px 110px 100px;
  align-items: center;
  gap: 10px;
`;

export const GroupContainer = styled.div`
  margin-bottom: 25px;
  width: 100%;
`;
export const ColumnLabels = styled.div`
  ${gridTemplate}
  padding: 0 20px 6px;
`;
export const ColumnLabel = styled.span`
  font-size: 12px;
  color: #777;
  text-align: center;
`;
export const GroupHeader = styled.div`
  ${gridTemplate}
  padding: 15px 20px;
  border-radius: 6px 6px 0 0;
  color: #fff;
  background-color: #1c1c1c;
`;
export const GroupTitle = styled.h3`
  font-size: 17px;
  font-weight: 600;
`;
export const HeaderValue = styled.span`
  font-size: 15px;
  font-weight: 600;
  text-align: center;
`;
export const RowsContainer = styled.div`
  padding-bottom: 5px;
  border-radius: 0 0 6px 6px;
  background-color: #fff;
`;
export const Row = styled.div`
  ${gridTemplate}
  padding: 12px 20px;
  background-color: ${({ $isEven }) => ($isEven ? "#fafafa" : "#fff")};
`;
export const RowInfo = styled.div`
  display: flex;
  flex-direction: column;
`;
export const RowName = styled.span`
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 600;
  color: #222;
`;
export const RowDescription = styled.span`
  padding-left: 12px;
  font-size: 12.5px;
  line-height: 1.45;
  color: #555;
  text-indent: -12px;
  &:before {
    content: "• ";
  }
`;
export const RowImage = styled.img`
  margin: 0 auto;
  max-width: 100%;
  max-height: 58px;
  object-fit: contain;
`;
export const RowValue = styled.span`
  font-size: 14px;
  color: #222;
  text-align: center;
`;
